a{text-decoration:none}ul{padding-bottom:10px}li{overflow-wrap:break-word}li p{white-space:pre-wrap;margin:0;padding:0}
/*# sourceMappingURL=rejection-history.component.css.map */
